import axios from '../helpers/axios'
import qs from 'querystring';
import { logError } from '../services';
import {
  IResponse, IProjectManagerUpdate,
  IProjectManagerActiveNeighborhood,
  IDropdownResponse
} from '../models';
import { IWarrantyUser, IWarrantyUserCreate, IWarrantyUserDetail } from "../models/warranty-users";

const baseUrl = "/api/warranty-users";
export const getWarrantyUsers = async (filters?: {
  neighborhoodId: string | number;
  sortDirection: string;
  searchTerm: string;
  perPage: number;
  territoryId: string | number;
  sortBy: string;
  page: number
}): Promise<IResponse<IWarrantyUser[]>> => {
  try {
    const { data } = await axios.get(baseUrl,{
      params: filters,
      paramsSerializer: params => qs.stringify(params)
    });
    return data;
  } catch (error: any) {
    logError(error, 'getWarrantyUsers failed');
    return Promise.reject(error.response.data);
  }
};

export const createWarrantyUser = async (payload: IWarrantyUserCreate): Promise<number> => {
  try {
    const { data } = await axios.post(baseUrl, payload);
    return data;
  } catch (error: any) {
    logError(error, 'createWarrantyUser failed');
    return Promise.reject(error.response.data);
  }
};

export const getWarrantyUserDetail = async (
  warrantyUserId: string | number
): Promise<IWarrantyUserDetail> => {
  try {
    const { data } = await axios.get(`${baseUrl}/${warrantyUserId}`);
    return data;
  } catch (error: any) {
    logError(error, 'getWarrantyUserDetail failed');
    return Promise.reject(error.response.data);
  }
};

export const updateWarrantyUser = async (
  warrantyUserId: string | number,
  payload: IProjectManagerUpdate
): Promise<any> => {
  try {
    const { data } = await axios.put(`${baseUrl}/${warrantyUserId}`, payload);
    return data;
  } catch (error: any) {
    logError(error, 'updateWarrantyUser failed');
    return Promise.reject(error.response.data);
  }
};
export const deleteWarrantyUser = async (warrantyUserId: string | number) => {
  try {
    const { data } = await axios.delete(`${baseUrl}/${warrantyUserId}`);
    return data;
  } catch (error: any) {
    logError(error, 'deleteWarrantyUser failed');
    return Promise.reject(error.response.data);
  }
};

export const getWarrantyUserAvailableNeighborhoods = async (
  projectManagerId: string | number
): Promise<IProjectManagerActiveNeighborhood[]> => {
  try {
    const { data } = await axios.get(
      `${baseUrl}/${projectManagerId}/available-neighborhoods`
    );
    return data;
  } catch (error: any) {
    logError(error, 'getProjectManagerAvailableNeighborhoods failed');
    return Promise.reject(error.response.data);
  }
};

export const createWarrantyUserNeighborhood = async (
  warrantyUserId: string | number,
  neighborhoodId: string | number
): Promise<any> => {
  try {
    const { data } = await axios.post(
      `${baseUrl}/${warrantyUserId}/neighborhoods/${neighborhoodId}`
    );
    return data;
  } catch (error: any) {
    logError(error, 'createProjectManagerNeighborhood failed');
    return Promise.reject(error.response.data);
  }
};

export const deleteWarrantyUserNeighborhood = async (
  warrantyUserId: string | number,
  neighborhoodId: string | number
): Promise<any> => {
  try {
    const { data } = await axios.delete(
      `${baseUrl}/${warrantyUserId}/neighborhoods/${neighborhoodId}`
    );
    return data;
  } catch (error: any) {
    logError(error, 'getProjectManagerAvailableNeighborhoods failed');
    return Promise.reject(error.response.data);
  }
};

export const getWarrantyUsersLookup = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`${baseUrl}/lookup`);

    return data;
  } catch (error: any) {
    logError(error, 'getWarrantyUsersLookup failed');
    return Promise.reject(error?.response?.data);
  }
};